import { UPLOAD_CAPABILITY_CONTRACT, UPLOAD_MEBIBYTE_BYTES } from '@repo/common';

const IMAGE_UPLOAD_CAPABILITY = UPLOAD_CAPABILITY_CONTRACT.find(capability => capability.resourceType === 'IMAGE');

if (!IMAGE_UPLOAD_CAPABILITY) {
  throw new Error('Image upload capability is not configured');
}

export const IMAGE_UPLOAD_SUPPORTED_EXTENSIONS: readonly string[] = IMAGE_UPLOAD_CAPABILITY.selectionFormats.flatMap(
  format => [...format.extensions],
);
export const IMAGE_UPLOAD_SUPPORTED_MIME_TYPES: readonly string[] = IMAGE_UPLOAD_CAPABILITY.selectionFormats.flatMap(
  format => [...format.mimeTypes],
);
export const IMAGE_UPLOAD_ACCEPT = [
  ...IMAGE_UPLOAD_SUPPORTED_MIME_TYPES,
  ...IMAGE_UPLOAD_SUPPORTED_EXTENSIONS.map(extension => `.${extension}`),
].join(',');

/** Product limit for images selected through shared image inputs. */
export const IMAGE_UPLOAD_MAX_FILE_SIZE_BYTES = IMAGE_UPLOAD_CAPABILITY.maxBytes;

export function formatImageUploadMaxFileSizeMessage(maxBytes: number): string {
  const maxMb = Math.round(maxBytes / UPLOAD_MEBIBYTE_BYTES);
  return `File is too large. Maximum size is ${maxMb}MB.`;
}
